import React from 'react';
import { View } from '@amzn/atoz-web/View';
import { styledWithTheme } from '@amzn/atoz-web/Theme';
import { ProgressBarHeight } from './ProgressBarTypes';
import { useProgressBar } from './useProgressBar';
import { Text } from '@amzn/atoz-web/Text';
import { Row } from '@amzn/atoz-web/Row';
export var ProgressBar = function (_a) {
    var progress = _a.progress, max = _a.max, ariaLabel = _a.ariaLabel, _b = _a.height, height = _b === void 0 ? ProgressBarHeight.Default : _b, labelPrimary = _a.labelPrimary, labelSecondary = _a.labelSecondary;
    var _c = useProgressBar({
        progress: progress,
        max: max,
        labelPrimary: labelPrimary,
        labelSecondary: labelSecondary
    }), progressPercent = _c.progressPercent, renderLabels = _c.renderLabels;
    return (React.createElement(View, { dataTestId: "progressBarWrapper", width: "100%" },
        React.createElement(ProgressBarContainer, { dataTestId: "progressBarContainer", role: "progressbar", "aria-label": ariaLabel, height: height },
            React.createElement(ProgressBarWithTheme, { dataTestId: "progressBar", progressPercent: progressPercent })),
        renderLabels && (React.createElement(Row, { alignItems: "center", dataTestId: "progressBarDescription", gridGap: "S300", margin: { top: 'S200' } },
            React.createElement(LabelRow, null,
                React.createElement(ProgressBarMarker, { filled: true }),
                React.createElement(Text, { dataTestId: "progressBarLabelPrimary", fontSize: "T200" }, labelPrimary)),
            React.createElement(LabelRow, null,
                React.createElement(ProgressBarMarker, { filled: false }),
                React.createElement(Text, { dataTestId: "progressBarLabelSecondary", fontSize: "T200" }, labelSecondary))))));
};
var ProgressBarContainer = styledWithTheme(View)(function (_a) {
    var theme = _a.theme, height = _a.height;
    return "\n        height: ".concat(height, ";\n        border-radius: 2em;\n        border: 1px solid ").concat(theme.selectors.color('primary90'), ";\n        display: flex;\n        overflow: hidden;\n    ");
});
var ProgressBarWithTheme = styledWithTheme(View)(function (_a) {
    var theme = _a.theme, progressPercent = _a.progressPercent;
    return "\n        width: ".concat(progressPercent, "%;\n        background: ").concat(theme.selectors.color('primary70'), ";\n        min-width: 0;\n        transition: width 0.6s ease;\n    ");
});
var ProgressBarMarker = styledWithTheme(View)(function (_a) {
    var theme = _a.theme, filled = _a.filled;
    return "\n        background-color: ".concat(filled ? theme.selectors.color('primary70') : 'white', ";\n        border-radius: 50%;\n        border: 1px solid ").concat(theme.selectors.color('primary90'), ";\n        height: 12px;\n        margin-right: ").concat(theme.selectors.space('S100'), "px;\n        width: 12px;\n    ");
});
var LabelRow = styledWithTheme(Row)(function () { return "\n        align-items: center;\n    "; });
